import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateCityCreate = {
  cityCreate: { data: null, loading: false, error: null },
};

export const cityCreate = createAsyncThunk('user/cityCreate', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .post(`/city/create`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerCityCreate = {
  [cityCreate.pending]: (state) => {
    state.cityCreate.loading = true;
  },
  [cityCreate.fulfilled]: (state, action) => {
    state.cityCreate.loading = false;
    state.cityCreate.data = action.payload;
    state.cityCreate.error = null;
  },
  [cityCreate.rejected]: (state, action) => {
    state.cityCreate.data = null;
    state.cityCreate.loading = false;
    state.cityCreate.error = action.payload;
  },
};
